<template>
  <b-alert class="sticky" dismissible :show="value" variant="success" fade @input="$emit('input', $event)">
    <slot></slot>
  </b-alert>
</template>

<script>
export default {
  props: ['value']
}
</script>

<style scoped>
.sticky {
  position: fixed !important;
  top: 0;
  width: 100%;
  z-index: 10;
}
</style>
